<h1 mat-dialog-title>
    {{title | translate}}
  </h1>
  <div mat-dialog-content>
    <!-- <p [innerHtml]="message"></p> -->
    <div>
      Verranno estratti {{rowsNumber}} record.
    </div>
    <mat-progress-bar style="margin: 20px 0 10px 0; " *ngIf="download"
      [mode]="download.state == 'PENDING' ? 'buffer' : 'determinate'" 
      [value]="download.progress">
    </mat-progress-bar>
  </div>
  <div mat-dialog-actions>
    <div class="layout horizontal space-between" style="width: 100%;">
      <app-button [label]="'CANCEL'|translate" icon="arrow-left" [mat-dialog-close]="null"></app-button>
      <div style="margin-inline-start: 10px;">
        <app-button [label]="'FILE_EXPORT_DIALOG.EXPORT'|translate" icon="check"
                    (click)="export()"
                    marginBefore='4px'></app-button>
      </div>
    </div>
  </div>


  <!-- <div *ngIf="download">
    download.state: {{download.state}} 
    download.progress: {{download.progress}}
  </div> -->
